import request from '@/utils/request'

// 获取管理员管理的群组列表
export function getManagedGroups(params) {
  return request({
    url: '/admin/group/list',
    method: 'get',
    params
  })
}

// 封禁群组
export function banGroup(groupId, reason) {
  return request({
    url: `/admin/group/${groupId}/ban`,
    method: 'put',
    params: { reason }
  })
}

// 解封群组
export function unbanGroup(groupId) {
  return request({
    url: `/admin/group/${groupId}/unban`,
    method: 'put'
  })
}

// 解散群组
export function dissolveGroup(groupId) {
  return request({
    url: `/admin/group/${groupId}`,
    method: 'delete'
  })
}

// 分配群组给管理员
export function assignGroupToAdmin(adminId, groupId) {
  return request({
    url: '/admin/group/assign',
    method: 'post',
    params: { adminId, groupId }
  })
}

// 全体禁言/解除全体禁言
export function muteGroup(groupId, muted) {
  return request({
    url: `/admin/group/${groupId}/mute`,
    method: 'put',
    params: { muted }
  })
}

// 获取群组列表
export function getGroupList(params) {
  return request({
    url: '/admin/group/list',
    method: 'get',
    params
  })
}

// 创建群组
export function createGroup(data) {
  return request({
    url: '/admin/group',
    method: 'post',
    data
  })
}

// 更新群组
export function updateGroup(groupId, data) {
  return request({
    url: `/admin/group/${groupId}`,
    method: 'put',
    data
  })
}

// 删除群组
export function deleteGroup(groupId) {
  return request({
    url: `/admin/group/${groupId}`,
    method: 'delete'
  })
}

// 更改群组状态
export function changeGroupStatus(groupId, status) {
  return request({
    url: `/admin/group/${groupId}/status`,
    method: 'put',
    params: { status }
  })
}

// 获取群成员列表
export function getGroupMembers(groupId, params) {
  return request({
    url: `/admin/group/${groupId}/members`,
    method: 'get',
    params
  })
}

// 添加群成员
export function addGroupMember(groupId, data) {
  return request({
    url: `/admin/group/${groupId}/members`,
    method: 'post',
    data
  })
}

// 移除群成员
export function removeGroupMember(groupId, memberId) {
  return request({
    url: `/admin/group/${groupId}/members/${memberId}`,
    method: 'delete'
  })
}

// 更新成员角色
export function updateMemberRole(groupId, memberId, role) {
  return request({
    url: `/admin/group/${groupId}/members/${memberId}/role`,
    method: 'put',
    params: { role }
  })
}
